export interface NextOfKin {
  NOKAddress: string;
  NOKCity: string;
  NOKState: string;
  NOKZipCode: string;
  NOKCountry: string;
}
